module.exports = __webpack_public_path__ + "img/basildon.80d14580.jpg";